import React from "react";
import "./fivethSection.css";
import fivethSectionImg from "../../assets/fivethSectionImg.png";
import Section5Element from "../section5Element/section5Element";
const FivethSection = () => {
  return (
    <div className="fivethSection-main-wrapper" style={{marginTop: '-5px'}}>
      <div className="fivethSection-inner-container">
        <div>
          <div className="fivethSection-roadmap-container">
            <h1>SIMPLIFIED ACTIVATION ROADMAP</h1>
            <p>
              Our team is in it for the long haul, not to make a quick buck. The
              community is our priority, and we want you to feel that.
              <br />
              <br />
              Once we hit certain sell points, we will activate our goal for
              that point and deploy it. You guys are in the driver seat!
            </p>
          </div>
          <div className="fivethSection-content-wrapper">
            <div className="fivethSection-elements">
                <Section5Element
                  percentageValue={"10% sold"}
                  paragraphInfo={"We throw a mini tater party"}
                />
                <Section5Element
                  percentageValue={"25% sold"}
                  paragraphInfo={
                    "5 ETH is added to the community fund for immediate giveaways through our discord."
                  }
                />
                <Section5Element
                  percentageValue={"40% sold"}
                  paragraphInfo={
                    "We release 5 potatoes who never made it to the party! 5 Lucky holders will get airdropped a rare party potato."
                  }
                />
                <Section5Element
                  percentageValue={"55% sold"}
                  paragraphInfo={
                    "We give back. $15,000 will be donated to a charity voted on by the community in our discord channel."
                  }
                />
                <Section5Element
                  percentageValue={"70% sold"}
                  paragraphInfo={"We unveil a SURPRISE!"}
                />
                <Section5Element
                  percentageValue={"85% sold"}
                  paragraphInfo={
                    "We purchase Metaverse land for our holders. Holders will be able to vote on it in the discord."
                  }
                />
                <Section5Element
                  percentageValue={"100%"}
                  paragraphInfo={
                    "We crank open a couple beers and celebrate! We add 5 more ETH to the community fund for immediate giveaways, activate our “Big Picture” roadmap."
                  }
                />
            </div>
            <div className="fivethSection-image">
              <img src={fivethSectionImg} alt="fivethSectionImg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FivethSection;
